import { render, staticRenderFns } from "./errorInAuth.vue?vue&type=template&id=ca082546&scoped=true&"
import script from "./errorInAuth.vue?vue&type=script&lang=js&"
export * from "./errorInAuth.vue?vue&type=script&lang=js&"
import style0 from "./errorInAuth.vue?vue&type=style&index=0&id=ca082546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca082546",
  null
  
)

export default component.exports